
// @ts-nocheck

import React, {Component} from 'react'
import { connect } from 'react-redux'
import PageButton from './PageButton'
import { PiArrowFatRightBold } from "react-icons/pi";
import { PiArrowFatLeftBold } from "react-icons/pi";
import {Droppable, Draggable, DragDropContext } from "react-beautiful-dnd"

const navigationButtonsIds = require('../Navigation/navigationButtonsIds');
const designerConstants = require('./constants');

class PageBarView extends Component 
{
    render()
    {  
        let pages = this.props.context.pages;
        let pageIndex = this.props.context.currentPageIndex;
        
        let page = pages[pageIndex];
        
        var components = [];
        for (let index = 0; index < designerConstants.maximumNoOfPageBarButtons; index++)
        {
            let button = index < page.buttons.length ? page.buttons[index] : navigationButtonsIds.blank;
            let marginLeft = index == 0 ? 'auto' : '30px';
            let marginRight = (index+1 == designerConstants.maximumNoOfPageBarButtons) ? "auto": "0px";

            let onDeleteButton = ()=>{this.props.onDelete(index, designerConstants.pageBarDroppableId)}
            let onAddButton = ()=>{this.props.onAdd(designerConstants.pageBarDroppableId)}

            components.push(this.createPageBarButton(index, button, onDeleteButton, onAddButton, marginLeft, marginRight));
        }

        

        let nextPageComponent = null;
        if (pageIndex+1 < pages.length)
        {
            let onClick=()=>
            {
                this.props.context.currentPageIndex = this.props.context.currentPageIndex + 1;
                this.setState({});
            };

            nextPageComponent = <div onClick={onClick} style={{position:'fixed', right:'0px', marginRight:'10px'}}>
                                    <div style={{height: window.innerWidth*0.12}}>
                                            <div style={{position:'relative', top:'50%', left:'50%', transform:'translate(-50%, -50%)', textAlign:'center'}}>
                                                <div style={{paddingLeft:'10px', paddingRight:'10px'}}>
                                                    <PiArrowFatRightBold className='primary-color' size="5rem" opacity={0.1}/> 
                                                </div>
                                            </div>
                                        </div>
                                </div>
        }

        let previousPageComponent = null;
        if (pageIndex > 0)
        {
            let onClick=()=>
            {
                this.props.context.currentPageIndex = this.props.context.currentPageIndex - 1;
                this.setState({});
            };

            previousPageComponent = <div onClick={onClick} style={{position:'fixed', left:'0px', marginLeft:'10px'}}>
                                    <div style={{height: window.innerWidth*0.12}}>
                                            <div style={{position:'relative', top:'50%', left:'50%', transform:'translate(-50%, -50%)', textAlign:'center'}}>
                                                <div style={{paddingLeft:'10px', paddingRight:'10px'}}>
                                                    <PiArrowFatLeftBold className='primary-color' size="5rem" opacity={0.1}/> 
                                                </div>
                                            </div>
                                        </div>
                                </div>
        }

        return <DragDropContext key="layout.designer.pagebar.drag.drop.context" onDragEnd={this.props.onDragEnd}>
                    <Droppable key={designerConstants.pageBarDroppableId} droppableId={designerConstants.pageBarDroppableId} direction="horizontal">
                        {(provided, snapshot) => (
                                                    <div ref={provided.innerRef} className="d-flex justify-content-center" style={{overflowX:'auto', width:Math.round(window.innerWidth * 0.99), marginBottom: '20vh'}}>
                                                        {previousPageComponent}
                                                        {components}
                                                        {nextPageComponent}
                                                        {provided.placeholder}
                                                    </div>
                                                )}
                    </Droppable>
                </DragDropContext>
    }

    createPageBarButton(index, button, onDelete, onAdd, marginLeft, marginRight)
    {
        return <Draggable key={`pageButton.${index}.key`} draggableId={`pageButton.${index}.id`} index={index}>
                                    {(provided, snapshot) => (
                                        <div ref={provided.innerRef} {...provided.draggableProps}{...provided.dragHandleProps}>
                                                <PageButton onDelete={onDelete} onAdd={onAdd} button={button} marginLeft={marginLeft} marginRight={marginRight}/>
                                        </div>
                                    )}
                    </Draggable>
    }
}

const mapStateToProps = state => 
{
    return { 
                layoutCurrentPageIndex: state.layoutCurrentPageIndex,
           }
}

export default connect(mapStateToProps)(PageBarView)
